/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ organizationName: NonNullable<unknown> }} Cool_Dry_Ant_RaceInputs */

const en_cool_dry_ant_race = /** @type {(inputs: Cool_Dry_Ant_RaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`User - ${i?.organizationName} | Kultify`)
};

const de_cool_dry_ant_race = /** @type {(inputs: Cool_Dry_Ant_RaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Benutzer - ${i?.organizationName} | Kultify`)
};

/**
* | output |
* | --- |
* | "User - {organizationName} \| Kultify" |
*
* @param {Cool_Dry_Ant_RaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_dry_ant_race = /** @type {((inputs: Cool_Dry_Ant_RaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Dry_Ant_RaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_dry_ant_race(inputs)
	return de_cool_dry_ant_race(inputs)
});